import { UserEncounterShortInfo } from 'api/encounters/types';

interface User {
  name: string;
  image: string;
}

const UserDataCell: React.FC<{ user?: User | UserEncounterShortInfo }> = ({ user }) => {
  if (user?.name) {
    return <>{user.name}</>;
  } else {
    return <h6 className="text-danger text-center">---</h6>;
  }
};

export default UserDataCell;
